export default __webpack_public_path__ + "static/media/_calculator_roas_active.73587782.svg";